import Vue from "vue";
import {BASE_URL, ENDPOINT_URL, REQUEST_API} from "./api";
import { addQueryToUrl } from "./util";
import {DOMAIN_AGENT_CODE, DOMAIN_AGENT_CODE_MAP} from "./constant";

export function userConfig1(params) {
  return new Promise((resolve, reject) => {
    Vue.http.get(`${BASE_URL}${REQUEST_API.userConfig}`, params).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

export function getInviteCodeFile() {
    return new Promise((resolve, reject) => {
        // https://gameag.s3.ap-east-1.amazonaws.com/land/invitedCode.json
        Vue.http.get(`/land/invitedCode.json`).then(
            res => {
                resolve(res);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function getGatagFile() {
    return new Promise((resolve, reject) => {
        // https://gameag.s3.ap-east-1.amazonaws.com/land/gtag.json

        Vue.http.get(`/land/gtag.json`).then(
            res => {
                resolve(res);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function userRegister(params, data) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${BASE_URL}${addQueryToUrl(data, REQUEST_API.userRegister)}`, params, {
      headers: {
        "accept-Language": "vi-VN,vi;"
      }
    })
      .then(
        res => {
          resolve(res);
            if (res.data.code === 0) {
                sendEndPoint({
                    "user_id": params.userName,
                    "phone": '',
                    "email": '',
                    "agent_line": DOMAIN_AGENT_CODE[location.host] || DOMAIN_AGENT_CODE_MAP.get(location.host),
                    "source": "8day",
                })
            }
        },
        error => {
          reject(error);
        }
      );
  });
}

export function userGetGoPageUrl(params, data) {
  return new Promise((resolve, reject) => {
    Vue.http.get(`${REQUEST_API.goPageUrl}`, params, {
      headers: {
        "accept-Language": "vi-VN,vi;"
      }
    })
      .then(
        res => {
          resolve(res);
            if (res.data.code === 0) {
                sendEndPoint({
                    "user_id": params.userName,
                    "phone": '',
                    "email": '',
                    "agent_line": DOMAIN_AGENT_CODE[location.host] || DOMAIN_AGENT_CODE_MAP.get(location.host),
                    "source": "8day",
                })
            }
        },
        error => {
          reject(error);
        }
      );
  });
}




export function userLogin(params) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${BASE_URL}${REQUEST_API.userLogin}`, params, {
      headers: {
        "accept-Language": "vi-VN,vi;"
      }
    }).then(
      res => {
        resolve(res);
          if (res.data.code === 0){
              sendEndPoint({
                  "user_id": params.userName,
                  "agent_line": DOMAIN_AGENT_CODE[location.host] || DOMAIN_AGENT_CODE_MAP.get(location.host),
                  "source": "8day",
              },false)
          }
      },
      error => {
        reject(error);
      }
    );
  });
}

export function getCode(params) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${BASE_URL}${REQUEST_API.getcode}`, params).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

export function createCustomer(params) {
  return new Promise((resolve, reject) => {
    Vue.http.post(REQUEST_API.createCustomer, params).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

export function sendEndPoint(params,isReg=true) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${ENDPOINT_URL}${isReg ? REQUEST_API.endpointReg : REQUEST_API.endpointLogin}`, params).then(
            res => {
                resolve(res);
            },
            error => {
                reject(error);
            }
        );
    });
}



// WEBPACK FOOTER //
// ./src/utils/request.js